// extracted by mini-css-extract-plugin
export default {"toolbar-column":"table-toolbar-cell_toolbar-column__Mg3gn","toolbar-icon":"table-toolbar-cell_toolbar-icon__87-Eb"};